import React from 'react'

const BackIcon = () => (
  <svg x="0px" y="0px" viewBox="0 0 32 32">
    <polygon points="28,15 7.8,15 17.4,5.4 16,4 4,16 16,28 17.4,26.6 7.8,17 28,17 " />
  </svg>
)

export default BackIcon
